import { appStorage, appSession } from './safeStorage';
// ONE source of truth for "which account am I", and the SINGLE helper that
// builds an account-scoped browser-storage key. BOTH guide layers reuse this —
// the floating How-To card (lib/guideStore) and the inline "How this works"
// strips (components/GuideStrip) — so neither can be scoped while the other
// leaks. Keys are namespaced by the signed-in user id (from /auth/me); until
// that id is known we fall back to a stable per-login namespace derived from
// the auth token already in app storage. All storage access stays in try/catch.

let currentNamespace = null;
const listeners = new Set();

// Stable short hash of the auth token — a per-login namespace used only until
// the real user id is handed in.
const tokenNamespace = () => {
  try {
    const t = appStorage.getItem('token') || appSession.getItem('token');
    if (!t) return null;
    let h = 0;
    for (let i = 0; i < t.length; i += 1) { h = (h * 31 + t.charCodeAt(i)) | 0; }
    return `tok_${(h >>> 0).toString(36)}`;
  } catch { return null; }
};

// Initialise synchronously from the token so a reload under the SAME login can
// read its state before React hands us the user id.
currentNamespace = tokenNamespace();

export const getGuideNamespace = () => currentNamespace;

// THE helper. Returns an account-scoped key, or null when nobody is known yet
// (callers then treat storage as absent → no guides for a signed-out browser).
export const namespacedKey = (baseKey) => {
  if (!baseKey || !currentNamespace) return null;
  return `${baseKey}__${currentNamespace}`;
};

export const subscribeGuideIdentity = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

// Called with the signed-in user id. On login / logout / account switch the
// namespace changes and every subscriber re-reads under the new identity, so a
// guide or strip from a previous account never renders for a new one.
export const setGuideIdentity = (identity) => {
  const ns = identity ? `uid_${identity}` : tokenNamespace();
  if (ns === currentNamespace) return;
  currentNamespace = ns;
  listeners.forEach((fn) => { try { fn(ns); } catch { /* no-op */ } });
};
